<template lang="">
  <v-main>
    <v-container fluid>
      <div>
        <v-row justify="center" align-content="center" class="mt-10">
          <img src="../../assets/loading.gif">
        </v-row>
      </div>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: 'LoadPage',
  mounted: function () {
    const pathParam = this.$route.params.path
    if (pathParam === 'search_result') {
      if (this.$route.query.search) {
        this.$router.push({ path: '/search_result', query: { search: this.$route.query.search } })
      } 
      if (this.$route.query.tag) {
        this.$router.push({ path: '/search_result', query: { tag: this.$route.query.tag } })
      }
    }
  }
}
</script>